import { Outlet, useLocation } from 'react-router-dom'
import { UserNav } from '@/components/user-nav'
import { GestorSidebar } from '@/components/gestor-sidebar'
import { GestorProvider, useGestor } from '@/contexts/GestorContext'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'

function GestorHeader() {
  const { areas, anos, areaSelecionada, setAreaSelecionada, anoSelecionado, setAnoSelecionado } = useGestor()
  const location = useLocation()

  const getPageTitle = (pathname: string) => {
    if (pathname === '/gestor') return 'Visão Geral'
    if (pathname.includes('/detalhamento')) return 'Detalhamento do orçamento'
    if (pathname.includes('/realizado-orcado')) return 'Realizado × orçado'
    if (pathname.includes('/alertas')) return 'Alertas de orçamento'
    if (pathname.includes('/verbas-adicionais')) return 'Verbas adicionais'
    if (pathname.includes('/movimentacoes')) return 'Histórico de Movimentações'
    return 'Painel do Gestor'
  }

  return (
    <header className="sticky top-0 z-40 border-b border-slate-200/80 bg-white shadow-sm">
      <div className="flex h-16 items-center justify-between gap-4 px-4 sm:px-6">
        
        {/* Left: Page Title */}
        <div className="flex items-center gap-4 flex-1 min-w-0">
          <h1 className="text-2xl font-bold tracking-tight text-[#131E29] truncate">
            {getPageTitle(location.pathname)}
          </h1>
        </div>

        {/* Right: Filters & Actions */}
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2 mr-4">
            <Select value={areaSelecionada} onValueChange={setAreaSelecionada}>
              <SelectTrigger className="w-[200px] h-9 bg-[#F8F9FA] border-slate-200/80 data-[state=open]:ring-orange-500/30">
                <SelectValue placeholder="Área" />
              </SelectTrigger>
              <SelectContent>
                {areas.map((area) => (
                  <SelectItem key={area.id} value={area.nome}>
                    {area.nome}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>

            <Select value={anoSelecionado} onValueChange={setAnoSelecionado}>
              <SelectTrigger className="w-[100px] h-9 bg-[#F8F9FA] border-slate-200/80 data-[state=open]:ring-orange-500/30">
                <SelectValue placeholder="Ano" />
              </SelectTrigger>
              <SelectContent>
                {anos.map((ano) => (
                  <SelectItem key={ano} value={String(ano)}>
                    {ano}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div className="flex items-center gap-3 pl-4 border-l">
            <UserNav />
          </div>
        </div>
      </div>
    </header>
  )
}

export default function GestorLayout() {
  return (
    <GestorProvider>
      <div className="flex h-screen overflow-hidden bg-white text-slate-900 font-sans">
        <GestorSidebar />
        <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
          <GestorHeader />
          <main className="flex-1 w-full min-w-0 overflow-y-auto px-4 py-6 sm:px-6 md:py-8">
            <Outlet />
          </main>
        </div>
      </div>
    </GestorProvider>
  )
}
